/** Campaign Desk routes. Every link is absolute. */
export const cdHref = (page: 'list' | 'new' | 'settings' = 'list'): string =>
  page === 'new' ? '/campaigns-desk/new' : page === 'settings' ? '/campaigns-desk/settings' : '/campaigns-desk'
export const campaignHref = (id: number): string => `/campaigns-desk/c/${id}`
/** The list showing only the campaigns one every-title brief started. */
export const groupHref = (groupId: number): string => `/campaigns-desk?group=${groupId}`

export type CdLink = { to: string; label: string }

/** The left-hand links, in order. */
export function cdNav(): CdLink[] {
  return [
    { to: cdHref(), label: 'Campaigns' },
    { to: cdHref('new'), label: 'New campaign' },
    { to: cdHref('settings'), label: 'Settings' },
  ]
}

/** Only admins and operators work the Campaign Desk. */
export const mayUseCampaignDesk = (role: string | undefined): boolean => role === 'admin' || role === 'operator'

export const TITLE_NAMES: Record<string, string> = {
  flight_journal: 'Flight Journal', model_airplane_news: 'Model Airplane News', rc_car_action: 'RC Car Action', diecast: 'Die Cast X',
}
export const titleName = (slug: string): string => TITLE_NAMES[slug] ?? slug
